import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  addQuotationh,
  getQtnJobList,
  setEstimationData,
} from "../../../../redux/feature/customer_app/customerV1Slice";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { formatDate } from "../../../../common/Validations";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import JobReivisonUpdate from "./JobReivisonUpdate";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import DeleteQuotationJob from "../Entry/DeleteQuotationJob";

const JobList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [filterShow, setFilterShow] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [data, setData] = useState();
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [modalDeleteQuotationJob, setModalDeleteQuotationJob] = useState(false);
  const [getEntryListData, setEntryListData] = useState();

  let jobData = useSelector((state) => state?.customerV1?.quotation_Job);
  let quotationTable = useSelector(
    (state) => state?.customerV1?.quotation_Job?.pagination
  );
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    setUserRole(userData?.roles?.[0]?.roleId || "");
  }, [userData]);

  const createEstimate = (jobRefNo) => {
    dispatch(addQuotationh(jobRefNo));
    dispatch(setEstimationData({}));
    navigate(CustomerConstants.CUSTOMER_V4_CUSTOMER_ESTIMATE_E1);
  };
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const loadJobData = async () => {
    setData(jobData?.data);
  };

  //modal calling
  const showUpdateModal = () => {
    setModalUpdate(true);
  };
  const hideUpdateModal = () => {
    setModalUpdate(false);
  };

  const handleEditClick = (row) => {
    dispatch(addQuotationh(row));
    showUpdateModal("EDIT", row.documentNumber, row.revision);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "Get_JOB_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getQtnJobList(obj));
    setData(jobData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "Get_JOB_LIST",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getQtnJobList(obj));
    setData(jobData?.data);
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "Get_JOB_LIST",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getQtnJobList(obj));
  };

  useEffect(() => {
    loadJobData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "Get_JOB_LIST",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getQtnJobList(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "Get_JOB_LIST",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getQtnJobList(obj));
  };

  const jobList = [
    {
      name: "Job Reference Nr",
      id: "jobReferenceNr",
      dropDown: true,
      selector: (row) => row?.jobReferenceNr,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-success-status">
            {row.jobReferenceNr}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Version",
      selector: (row) => row?.version,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-success-status">
            {row.version}
          </span>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Revision",
      selector: (row) => row.documentNumber || "--",
      cell: (row) => (
        <div>
          <button
            className="btn d-flex align-items-center w-100"
            onClick={() => handleEditClick(row.documentNumber, row.revision)}
          >
            <i class="bi bi-repeat pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Revision</sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Estimate ",
      selector: (row) => row.documentNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btnInfo"
          onClick={() => createEstimate(row.documentNumber)}
          disabled={
            row?.estimationNr || row?.estimationNr === "" ? true : false
          }
        >
          <i className="bi bi-plus-lg"></i> Create
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row?.estHeaderStatus,
      cell: (row) => (
        <>
          {/* <span class="text-primary fw-bold">{row.estimationStatus}</span> */}
          <TableStatusField status={row.estHeaderStatus} />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Client/Company",
      selector: (row) => row.companyName,
      id: "companyName",
      dropDown: true,
      cell: (row) => (
        <div>
          <p class="">{row.companyName}</p>
          <p class="fw-bold">{row.clientName}</p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Building Structure",
      selector: (row) => row.buildingName,
      cell: (row) => (
        <div>
          <p className="">{row.buildingName} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Location",
      id: "location",
      dropDown: true,
      selector: (row) => row.location,
      cell: (row) => (
        <div>
          <p className=" ">{row.location} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Created Date/Time",
      id: "createdAt",
      dropDown: true,
      selector: (row) => row.createdAt,
      cell: (row) => (
        <div>
          {/* <p className=" ">{row.location} </p> */}
            <p className="d-block fw-bold">
  {new Date(row.createdAt).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })}
</p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Attachments",
      selector: (row) => row.supportingDoc,
      cell: (row) => (
        <>
          {row?.supportingDoc && row.supportingDoc.length > 0 ? (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.supportingDoc)}
            />
          ) : (
            "--"
          )}
        </>
      ),
      sortable: true,
      width: "160px",
    },

    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}
                  <strong>Estimation Date:</strong>{" "}
                  {formatDate(row.estimationDate)} <br />
                  <strong>Building Strucutre:</strong>{" "}
                  {row?.buildingName || "--"}
                  <br />
                  <strong>Checker:</strong> {row?.checkerName || "--"}
                  <br />
                  <strong>Remarks:</strong> {row?.remarks || "--"}
                  <br />
                  <strong>Job Nr:</strong> {row?.documentNumber || "--"}
                  <br />
                  <strong>Created By:</strong> {row?.createdBy || "--"}
                  <br />
                  <strong>Created Name:</strong> {row?.createdName || "--"}
                  <br />
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "175px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteQuotaionJob(row)}>
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      omit: userRole !== "DESIGN-MANAGER",
      sortable: true,
      width: "200px",
    },
  ];

  const columnsForFilter = jobList
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //delete
  const deleteQuotaionJob = (data) => {
    setModalDeleteQuotationJob(true);
    setEntryListData(data);
  };

  const hideModal = () => {
    setModalDeleteQuotationJob(false);
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Job List</h2>
                <p className="subText">Job List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={data}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}

            {/* user list */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">JL</span>
                    </Col>
                    <Col xs={6} md={6} lg={6}>
                      <span className="headerTitle"> Job List</span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <div className="filter">
                        <span
                          className="icon hide headerIcon"
                          data-bs-toggle="dropdown"
                          aria-expanded="true"
                        >
                          <i className="bi bi-three-dots"></i>
                        </span>
                        <ul
                          className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                          data-popper-placement="bottom-end"
                        >
                          <li className="dropdown-header text-start">
                            <h6>Menu</h6>
                          </li>
                          <li>
                            <span>
                              <i className="bi bi-download"></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <StickyColumn
                          columnIndexes={[2, 3, 4, 5]}
                          leftOffsets={[0, 160, 280, 400]}
                        />
                        <DataTable
                          title=""
                          columns={jobList}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          onChangeRowsPerPage={handlePerRowsChange}
                          paginationTotalRows={quotationTable.total}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <JobReivisonUpdate show={modalUpdate} onHide={() => hideUpdateModal()} />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <DeleteQuotationJob
        show={modalDeleteQuotationJob}
        onHide={() => hideModal()}
        data={getEntryListData}
        // dropdownData={getAccountGroup}
      />
    </main>
  );
};

export default JobList;
